import * as React from 'react';
import { Box } from '@mui/material';
import { Link } from 'gatsby';

interface LogoButtonProps {
  route: string;
  imageSource: string;
}

export function ImageButton({ route, imageSource }: LogoButtonProps) {
  return (
    <Link to={`/${route}`} aria-label="Go to the Priority Health homepage">
      <Box
        component="img"
        className="site_logo"
        alt="Priority Health Logo"
        
        sx={{
          width: 350,
          maxWidth: { xs: 150, md: 250 }
        }}
        src={imageSource}
      ></Box>
    </Link>
  );
}
